// import { genDirectiveDownloadUrl } from '@/services/utils'
import apiDownload from '@/services/api/modules/download'
import { ASYNC_EXPORT_CODE_ENUM, ASYNC_EXPORT_COLUMN_TYPE_ENUM } from '@/services/enums'
import { createAsyncExportTask } from '@/services/utils/modules/download'
import request from '../../request'

export default {
  financesReceivable: {
    url: '/listAmazonFinancesReceivable',
    method: 'post',
    desc: '财务-回款记录',
  },
  getAmazonMatchGroupTip: {
    url: '/amazonMatchGroupTip',
    method: 'post',
    desc: '财务-异常账期-数量',
  },
  pageAmazonMatchGroup: {
    url: '/pageAmazonMatchGroup',
    method: 'post',
    desc: '财务-异常账期-列表',
  },
  updateAmazonMatchGroup: {
    url: '/updateAmazonMatchGroup',
    method: 'post',
    desc: '财务-异常账期-更新账期',
  },
  getPageAmazonMatchDetail: {
    url: '/pageAmazonMatchDetail',
    method: 'post',
    desc: '财务-异常账期-异常明细',
  },

  listFinancesSettlement: {
    url: '/listFinancesSettlement',
    method: 'post',
    desc: '财务-结算明细-amazon',
  },
  amazonSettlementLackTip: {
    url: '/amazonSettlementLackTip',
    method: 'post',
    desc: '财务-结算明细-amazon-缺失提示',
  },
  getOrderIncome: {
    url: '/orderEsc/getOrderIncome',
    method: 'post',
    desc: '财务-结算明细-shopee-订单',
  },
  getSettleDetailBySku: {
    url: '/orderEsc/getSettleDetailBySku',
    method: 'post',
    desc: '财务-结算明细-shopee-子订单',
  },
  getTotalAmountByOrder: {
    url: '/orderEsc/getTotalAmountByOrder',
    method: 'post',
    desc: '财务-结算明细-shopee-总计-订单',
  },
  getTotalAmountBySku: {
    url: '/orderEsc/getTotalAmountBySku',
    method: 'post',
    desc: '财务-结算明细-shopee-总计-子订单',
  },
  getTransactionOrder: {
    url: '/lazadaFinance/getOrderTransaction',
    method: 'post',
    desc: '财务-结算明细-lazada-订单',
  },
  getTransactionOrderItem: {
    url: '/lazadaFinance/getOrderItemTransaction',
    method: 'post',
    desc: '财务-结算明细-lazada-子订单',
  },
  getStatementList: {
    url: '/lazadaFinance/getStatementList',
    method: 'post',
    desc: '财务-结算明细-lazada-账单筛选列表',
  },
  getOrderTransactionTotal: {
    url: '/lazadaFinance/getOrderTransactionTotal',
    method: 'post',
    desc: '财务-结算明细-lazada-订单-总计',
  },
  getOrderItemTransactionTotal: {
    url: '/lazadaFinance/getOrderItemTransactionTotal',
    method: 'post',
    desc: '财务-结算明细-lazada-子订单-总计',
  },
  getTransactionDetail: {
    url: '/lazadaFinance/getTransactionDetail',
    method: 'post',
    desc: '财务-费用明细-lazada',
  },
  getTransactionTotal: {
    url: '/lazadaFinance/getTransactionTotal',
    method: 'post',
    desc: '财务-费用明细-lazada-总计',
  },
  aeFinace: {
    url: '/aeFinace/detail',
    method: 'post',
    desc: '财务-结算明细-速卖通-订单',
  },
  aeFinaceChildOrder: {
    url: '/aeFinace/product/detail',
    method: 'post',
    desc: '财务-结算明细-速卖通-子订单',
  },
  listAmazonMerchantSkuProfitReport: {
    url: '/listAmazonMerchantSkuProfitReport',
    method: 'post',
    desc: '财务-平台结算-amazon-sku',
  },
  summaryAmazonMerchantSkuProfitReport: {
    url: '/summaryAmazonMerchantSkuProfitReport',
    method: 'post',
    desc: '财务-平台结算-amazon-sku',
  },
  listAmazonProfitStoreReport: {
    url: '/listAmazonProfitStoreReport',
    method: 'post',
    desc: '财务-平台结算-amazon-店铺-明细',
  },
  summaryAmazonProfitStoreReport: {
    url: '/summaryAmazonProfitStoreReport',
    method: 'post',
    desc: '财务-总计-amazon-店铺-总览',
  },
  listAmazonStoreProfitPreview: {
    url: '/listAmazonStoreProfitPreview',
    method: 'post',
    desc: '财务-平台结算-amazon-店铺-总览',
  },
  pageAmazonOrderProfitReport: {
    url: '/pageAmazonOrderProfitReport',
    method: 'post',
    desc: '财务-平台结算-amazon-订单总览',
  },
  amazonOrderProfitTotal: {
    url: '/amazonOrderProfitTotal',
    method: 'post',
    desc: '财务-总计-amazon-订单总览',
  },
  recosting: {
    url: '/recosting',
    method: 'post',
    desc: '亚马逊-利润报表- 成本重算',
  },
  amazonCostMissingTip: {
    url: '/amazonCostMissingTip',
    method: 'post',
    desc: '亚马逊-利润报表- 无成本引导提示',
  },
  amazonCostMissingDetail: {
    url: '/amazonCostMissingDetail',
    method: 'post',
    desc: '亚马逊-利润报表- 无成本引导详情',
  },

  listAmazonAsinProfitReport: {
    url: '/listAmazonAsinProfitReport',
    method: 'post',
    desc: '财务-平台结算-amazon-asin',
  },
  summaryAmazonAsinProfitReport: {
    url: '/summaryAmazonAsinProfitReport',
    method: 'post',
    desc: '财务-总计-amazon-asin',
  },
  getProfitReportBySku: {
    url: '/reports/getSkuReport',
    method: 'post',
    desc: '财务-平台结算-shopee-sku',
  },
  getProfitReportByShop: {
    url: '/reports/getShopReport',
    method: 'post',
    desc: '财务-平台结算-shopee-店铺',
  },
  getProfitReportShopeeByOrder: {
    url: '/reports/getProfitReportByOrder',
    method: 'post',
    desc: '财务-利润报表-shopee-订单维度',
  },
  getProfitReportShopeeByOrderChildOrder: {
    url: '/reports/getProfitReportByOrderItems',
    method: 'post',
    desc: '财务-利润报表-shopee-订单维度',
  },
  // shopee - 总计
  getProfitReportByOrderTotal: {
    url: '/reports/getProfitReportByOrder/total',
    method: 'post',
    desc: '财务-平台结算-shopee-订单-总计',
  },
  getProfitReportByOrderItemsTotal: {
    url: '/reports/getProfitReportByOrderItems/total',
    method: 'post',
    desc: '财务-平台结算-shopee-子订单-总计',
  },
  getSkuReportTotal: {
    url: '/reports/getSkuReport/total',
    method: 'post',
    desc: '财务-平台结算-shopee-sku-总计',
  },
  getShopReportTotal: {
    url: '/reports/getShopReport/total',
    method: 'post',
    desc: '财务-平台结算-shopee-店铺-总计',
  },
  getShopTransaction: {
    url: '/lazadaFinance/getShopProfit',
    method: 'post',
    desc: '财务-平台结算-lazada-店铺',
  },
  getShopTransactionTotal: {
    url: '/lazadaFinance/getShopTransactionTotal',
    method: 'post',
    desc: '财务-平台结算-lazada-店铺-总计',
  },
  getSkuTransaction: {
    url: '/lazadaFinance/getSkuProfit',
    method: 'post',
    desc: '财务-利润报表-lazada-sku',
  },
  getSkuTransactionTotal: {
    url: '/lazadaFinance/getSkuProfitForTotal',
    method: 'post',
    desc: '财务-平台结算-lazada-sku-总计',
  },
  getShopAliexpress: {
    url: '/aeFinace/profit/shop',
    method: 'post',
    desc: '财务-平台结算-速卖通-店铺-列表',
  },
  getProductAliexpress: {
    url: '/aeFinace/profit/product',
    method: 'post',
    desc: '财务-平台结算-速卖通-商品-列表',
  },
  getOrderAliexpress: {
    url: '/aeFinace/profit/order',
    method: 'post',
    desc: '财务-平台结算-速卖通-订单-列表',
  },
  getProfitAliExpressAbnormallTips: {
    url: '/aeFinance/profit/order/tips',
    method: 'post',
    desc: '财务-利润报表-速卖通-异常提示',
  },
  getProfitSettlementListAliExpressChildOder: {
    url: '/aeFinance/profit/order/item',
    method: 'post',
    desc: '财务-利润报表-列表-速卖通-子订单',
  },
  getProfitSettlementListAliExpressCountry: {
    url: '/aeFinance/profit/country',
    method: 'post',
    desc: '财务-利润报表-列表-速卖通-国家',
  },
  listAmazonAdCheckingOverview: {
    url: '/listAmazonAdCheckingOverview',
    method: 'post',
    desc: '财务-平台对账-amazon-总揽',
  },
  listAmazonAdCheckingDetail: {
    url: '/listAmazonAdCheckingDetail',
    method: 'post',
    desc: '财务-平台对账-amazon-明细',
  },
  getListShopeeAdjustFeeOrder: {
    url: '/orderEsc/getAdjustmentOrder',
    method: 'post',
    desc: '财务-shopee-调整费-订单',
  },
  getStatisticsShopeeAdjustFeeOrder: {
    url: '/orderEsc/getTotalAdjustmentOrder',
    method: 'post',
    desc: '财务-shopee-调整费-订单-统计信息',
  },
  getListShopeeAdjustFeeSubOrder: {
    url: '/orderEsc/getAdjustmentSku',
    method: 'post',
    desc: '财务-shopee-调整费-子订单',
  },
  getStatisticsShopeeAdjustFeeSubOrder: {
    url: '/orderEsc/getTotalAdjustmentSku',
    method: 'post',
    desc: '财务-shopee-调整费-子订单-统计信息',
  },
  getProfitReportLazadaOrderChildOrder: {
    url: '/lazadaAggregationOrderItem/selectLazadaAggregationOrderItem',
    method: 'post',
    desc: '财务-利润报表-lazada-订单-子订单',
  },
  getProfitReportLazadaOrderChildOrderTotal: {
    url: '/lazadaAggregationOrderItem/getTotalByOrderItem',
    method: 'post',
    desc: '财务-利润报表-lazada-订单-子订单',
  },
  getProfitReportLazadaOrderOrder: {
    url: '/lazadaAggregationOrderItem/selectLazadaAggregationOrder',
    method: 'post',
    desc: '财务-利润报表-lazada-订单-订单',
  },
  getProfitReportLazadaOrderOrderTotal: {
    url: '/lazadaAggregationOrderItem/getTotalByOrder',
    method: 'post',
    desc: '财务-利润报表-lazada-订单-订单',
  },
  fetchListAliExpressBill: (data, options = {}) => {
    return request(
      {
        url: '/aeBill/list',
        method: 'post',
        desc: '获取数买通账单列表',
      },
      data,
      options
    )
  },
  fetchAliExpressImportBill: (data, options = {}) => {
    return request(
      {
        url: '/aeFinace/acct/callBack',
        method: 'post',
        desc: '',
      },
      data,
      options
    )
  },
  /**
   * 获取利润报表的更新记录
   * @param {} data
   * @param {*} options
   * @returns
   */
  getReportUpdateTaskList: (data = {}, options = {}) => {
    return request(
      {
        url: '/task/list',
        method: 'get',
        desc: '',
      },
      data,
      options
    )
  },
  /**
   * 获取利润报表的日志更新状态
   * @param {} data
   * @param {*} options
   * @returns
   */
  getReportUpdateLogTips: (data = {}, options = {}) => {
    return request(
      {
        url: '/task/logTips',
        method: 'post',
        desc: '',
      },
      data,
      options
    )
  },
  /**
   * 获取利润报表的更新记录
   * @param {} data
   * @param {*} options
   * @returns
   */
  getReportUpdateTaskPage: (data = {}, options = {}) => {
    return request(
      {
        url: '/task/page',
        method: 'post',
        desc: '',
      },
      data,
      options
    )
  },
  /**
   * 更新记录重试
   * @param {} data
   * @param {*} options
   * @returns
   */
  updateRecordRetry: (data = {}, options = {}) => {
    return request(
      {
        url: '/task/retry',
        method: 'post',
        desc: '',
      },
      data,
      options
    )
  },
  /**
   * 删除账单 结算明细 速卖通
   * @param {*} data {id: string}
   * @param {*} options
   * @returns
   */
  fetchAESettlementDetailDelBill: (data = {}, options = {}) => {
    return request(
      {
        url: '/aeBill/deleteBill',
        method: 'get',
        desc: '',
      },
      data,
      options
    )
  },
  /**
   * 获取Lazada账期可选项
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchLazadaStatementList: (data = {}, options = {}) => {
    return request(
      {
        url: '/lazadaFinance/getStatementList',
        method: 'post',
        desc: '',
      },
      data,
      options
    )
  },
  /**
   * 获取 Lazada利润报表， 订单维度, 其他费气泡内容
   * @param {*} apiTradeOrderTid 平台订单号
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchProfitReportLazadaOrderOtherFeeGeneral(
    data = {},
    options = {}
  ) {
    return request(
      {
        url: '/lazadaAggregationOrderItem/selectOrderOtherFeeDetail',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchProfitReportLazadaOrderChildOrderOtherFee(
    apiTradeOrderOid,
    data = {},
    options = {}
  ) {
    return request(
      {
        url: '/lazadaAggregationOrderItem/selectOtherFeesOrdersItemDetail',
        method: 'post',
        desc: '',
      },
      {
        ...data,
        apiTradeOrderOid,
      },
      options
    )
  },
  fetchProfitReportLazadaOrderOrderOtherFee(
    apiTradeOrderTid,
    data = {},
    options = {}
  ) {
    return request(
      {
        url: '/lazadaAggregationOrderItem/selectOtherFeesOrdersDetail',
        method: 'post',
        desc: '',
      },
      {
        ...data,
        apiTradeOrderTid,
      },
      options
    )
  },
  /**
   * 获取利润报表 shopee 订单其他费
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchProfitReportShopeeOrderOtherFee(data = {}, options = {}) {
    return request(
      {
        url: '/orderEsc/otherFeeDetail',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 获取利润报表 amazon 浮层（adAmount：广告费、purchaseCostAmount：FBA采购成本、fbaFirstTripCostAmount：FBA头程费用）
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchProfitReportAmazonProfitSupernatant(data = {}, options = {}) {
    return request(
      {
        url: '/amazonProfitSupernatant',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 利润报表 虾皮 重算采购成本
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchProfitReportShopeeRecomputeCost(data = {}, options = {}) {
    return request(
      {
        url: '/orderEsc/recomputeCost',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 利润报表 lazada 重算采购成本
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchProfitReportLazadaRecomputeCost(data = {}, options = {}) {
    return request(
      {
        url: '/lazadaAggregationOrderItem/historicalCostRecalculationForOrderItem',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 利润报表 aliexpress 重算采购成本
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchProfitReportAliexpressRecomputeCost(data = {}, options = {}) {
    return request(
      {
        // todo
        url: '/aeFinance/profit/compute',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 下载利润报表 虾皮 订单维度
   * @param {*} reqData
   */
  downloadProfitReportShopeeByOrder(reqData) {
    // const url = genDirectiveDownloadUrl(`${process.env.VUE_APP_BASE_API}/reports/downloadReportByOrderExcel`, reqData)
    // console.log('即将打开url:', url)
    // window.open(url)
    apiDownload.fetchDownloadPostGeneric(
      '/reports/downloadReportByOrderExcel',
      reqData
    )
  },
  /**
   * 下载利润报表 虾皮 订单维度
   * @param {*} reqData
   */
  downloadProfitReportShopeeByOrderChildOrder(reqData) {
    // const url = genDirectiveDownloadUrl(`${process.env.VUE_APP_BASE_API}/reports/downloadReportByOrderItemsExcel`, reqData)
    // console.log('即将打开url:', url)
    // window.open(url)
    apiDownload.fetchDownloadPostGeneric(
      '/reports/downloadReportByOrderItemsExcel',
      reqData
    )
  },
  downloadProfitReportShopeeBySku(reqData) {
    // const url = genDirectiveDownloadUrl(`${process.env.VUE_APP_BASE_API}/reports/downSkuReportExcel`, reqData)
    // console.log('即将打开url:', url)
    // window.open(url)
    // apiDownload.fetchDownloadGetToPost(url)
    apiDownload.fetchDownloadPostGeneric(
      '/reports/downSkuReportExcel',
      reqData
    )
  },
  downloadProfitReportShopeeByShop(reqData) {
    // const url = genDirectiveDownloadUrl(`${process.env.VUE_APP_BASE_API}/reports/downShopReportExcel`, reqData)
    // console.log('即将打开url:', url)
    // window.open(url)
    // apiDownload.fetchDownloadGetToPost(url)
    apiDownload.fetchDownloadPostGeneric(
      '/reports/downShopReportExcel',
      reqData
    )
  },
  /**
   * 下载利润报表 lazada 订单-子订单
   * @param {*} reqData
   */
  downloadProfitReportLazadaByOrderChildOrder(reqData, data) {
    // const url = genDirectiveDownloadUrl(`${process.env.VUE_APP_BASE_API}/lazadaAggregationOrderItem/downLoadLazadaAggregationOrderItem`, reqData)
    // console.log('即将打开url:', url)
    // window.open(url)
    // apiDownload.fetchDownloadGetToPost(url)
    // return apiDownload.fetchCreateAsyncDownloadTask(
    //   ASYNC_EXPORT_CODE_ENUM.EXCEL_LAZADA_PROFIT_ORDER_DETAIL.value,
    //   ASYNC_EXPORT_COLUMN_TYPE_ENUM.csv.value,
    //   reqData,
    // )
    // apiDownload.fetchDownloadPostGeneric(
    //   '/lazadaAggregationOrderItem/downLoadLazadaAggregationOrderItem',
    //   reqData
    // )

    createAsyncExportTask(
      ASYNC_EXPORT_CODE_ENUM.EXCEL_LAZADA_PROFIT_ORDER_DETAIL.value,
      ASYNC_EXPORT_COLUMN_TYPE_ENUM.excel.value,
      reqData,
      data,
    )
  },
  /**
   * 下载利润报表 lazada 订单-订单
   * @param {*} reqData
   */
  downloadProfitReportLazadaByOrderOrder(reqData, data) {
    // const url = genDirectiveDownloadUrl(`${process.env.VUE_APP_BASE_API}/lazadaAggregationOrderItem/downLoadLazadaAggregationOrder`, reqData)
    // console.log('即将打开url:', url)
    // window.open(url)
    // apiDownload.fetchDownloadGetToPost(url)
    // apiDownload.fetchDownloadPostGeneric(
    //   '/lazadaAggregationOrderItem/downLoadLazadaAggregationOrder',
    //   reqData
    // )

    // return apiDownload.fetchCreateAsyncDownloadTask(
    //   ASYNC_EXPORT_CODE_ENUM.EXCEL_LAZADA_PROFIT_ORDER.value,
    //   ASYNC_EXPORT_COLUMN_TYPE_ENUM.csv.value,
    //   reqData
    // )

    createAsyncExportTask(
      ASYNC_EXPORT_CODE_ENUM.EXCEL_LAZADA_PROFIT_ORDER.value,
      ASYNC_EXPORT_COLUMN_TYPE_ENUM.excel.value,
      reqData,
      data,
    )
  },
  downloadProfitReportLazadaByShop(reqData, data) {
    // const url = genDirectiveDownloadUrl(`${process.env.VUE_APP_BASE_API}/lazadaFinance/downloadShopProfit`, reqData)
    // console.log('即将打开url:', url)
    // window.open(url)
    // apiDownload.fetchDownloadGetToPost(url)
    // apiDownload.fetchDownloadPostGeneric(
    //   '/lazadaFinance/downloadShopProfit',
    //   reqData
    // )

    // return apiDownload.fetchCreateAsyncDownloadTask(
    //   ASYNC_EXPORT_CODE_ENUM.EXCEL_LAZADA_PROFIT_SHOP.value,
    //   ASYNC_EXPORT_COLUMN_TYPE_ENUM.csv.value,
    //   reqData
    // )

    createAsyncExportTask(
      ASYNC_EXPORT_CODE_ENUM.EXCEL_LAZADA_PROFIT_SHOP.value,
      ASYNC_EXPORT_COLUMN_TYPE_ENUM.excel.value,
      reqData,
      data,
    )
  },
  downloadProfitReportLazadaBySku(reqData, data) {
    // const url = genDirectiveDownloadUrl(`${process.env.VUE_APP_BASE_API}/lazadaFinance/downloadShopProfit`, reqData)
    // console.log('即将打开url:', url)
    // window.open(url)
    // apiDownload.fetchDownloadGetToPost(url)
    // return apiDownload.fetchCreateAsyncDownloadTask(
    //   ASYNC_EXPORT_CODE_ENUM.EXCEL_LAZADA_PROFIT_SKU.value,
    //   ASYNC_EXPORT_COLUMN_TYPE_ENUM.csv.value,
    //   reqData
    // )

    createAsyncExportTask(
      ASYNC_EXPORT_CODE_ENUM.EXCEL_LAZADA_PROFIT_SKU.value,
      ASYNC_EXPORT_COLUMN_TYPE_ENUM.excel.value,
      reqData,
      data,
    )
  },
  /**
   * 获取应收明细列表  shopee平台
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchReceivableDetailListShopee(data = {}, options = {}) {
    return request(
      {
        url: '/check/getReceivableDetail',
        method: 'post',
        desc: '获取应收明细列表',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 应收明细-总计-shopee
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchReceivableDetailTotalShopee(data = {}, options = {}) {
    return request(
      {
        url: '/check/recivable/total',
        method: 'post',
        desc: '应收明细-总计-shopee',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 获取应收明细列表  lazada平台
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchReceivableDetailListLazada(data = {}, options = {}) {
    return request(
      {
        url: '/lazada/finance/receivable/notes',
        method: 'post',
        desc: '获取应收明细列表',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 获取应收明细合计  lazada平台
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchReceivableDetailTotalLazada(data = {}, options = {}) {
    return request(
      {
        url: '/lazada/finance/receivable/sum',
        method: 'post',
        desc: '获取应收明细列表',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 获取应收明细列表  aliexpress平台
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchReceivableDetailListAliExpress(data = {}, options = {}) {
    return request(
      {
        url: '/aeFinance/getReceivableDetail',
        method: 'post',
        desc: '获取应收明细列表',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 查询创建人
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchCreateUserList(data = {}, options = {}) {
    return request(
      {
        url: '/check/queryCreatorInfo',
        method: 'get',
        desc: '查询创建人',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 批量删除应收明细  shopee
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchBatchDelReceivableDetailShopee(data = {}, options = {}) {
    return request(
      {
        url: '/check/removeByIds',
        method: 'post',
        desc: '获取应收明细列表',
      },
      data,
      options
    )
  },
  /**
   * 获取对账管理列表  shopee平台
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchCheckAccountInfoListShopee(data = {}, options = {}) {
    return request(
      {
        url: '/check/queryCheckAccountInfo',
        method: 'post',
        desc: '获取对账管理列表',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
 * 对账管理-核销  shopee
 * @param {*} data
 * @param {*} options
 * @returns
 */
  fetchVerificationShopee(data = {}, options = {}) {
    return request(
      {
        url: '/check/verification',
        method: 'post',
        desc: '对账管理核销',
      },
      data,
      options
    )
  },
  /**
 * 对账管理-核销记录  shopee
 * @param {*} data
 * @param {*} options
 * @returns
 */
  getVerificationRecord(data = {}, options = {}) {
    return request(
      {
        url: '/check/getVerificationRecord',
        method: 'post',
        desc: '对账管理核销记录',
      },
      data,
      options
    )
  },
  /**
 * 对账管理-核销重试  shopee
 * @param {*} data
 * @param {*} options
 * @returns
 */
  fetchReVerification(data = {}, options = {}) {
    return request(
      {
        url: '/check/reVerification',
        method: 'get',
        desc: '对账管理核销重试',
      },
      data,
      options
    )
  },
  /**
   * 应收明细修改单据时间和备注 shopee平台
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchModifyReceivableDetailShopee(data = {}, options = {}) {
    return request(
      {
        url: '/check/modifyReceivableDetail',
        method: 'post',
        desc: '应收明细修改单据时间和备注',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 批量修改备注，对账管理
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchBatchModifyRemoarkCheckMgt(data = {}, options = {}) {
    return request(
      {
        url: '/check/modifyBatchRemark',
        method: 'post',
        desc: '批量修改备注-对账管理',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 创建货运调整 创建退回应收单
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchCreateFreightAdjustmentNote(data = {}, options = {}) {
    return request(
      {
        url: '/check/create/FreightAdjustmentNote',
        method: 'post',
        desc: '批量修改备注-对账管理',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 应收明细 - 导入记录
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchAsyncImportPage(data = {}, options = {}) {
    return request(
      {
        url: '/asyncImport/page',
        method: 'post',
        desc: '应收明细 - 导入记录',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * amazon 对账 仓储费 总览 列表数据
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchListAmazonCheckStorageOverview(data = {}, options = {}) {
    return request(
      {
        url: '/amazon/checking/storage/overview',
        method: 'post',
        desc: ' amazon 对账 仓储费 总览 列表数据',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * amazon 对账 仓储费 明细 列表数据
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchListAmazonCheckStorageDetail(data = {}, options = {}) {
    return request(
      {
        url: '/amazon/checking/storage/detail',
        method: 'post',
        desc: ' amazon 对账 仓储费 详细 列表数据',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * amazon 对账 LD费 总览 列表数据
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchListAmazonLightningDealOverview(data = {}, options = {}) {
    return request(
      {
        url: '/amazonLightningShare/pageAmazonLightningShare',
        method: 'post',
        desc: ' amazon 对账 LD费 总览 列表数据',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * amazon 对账 LD费 明细 列表数据
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchListAmazonLightningDealDetail(data = {}, options = {}) {
    return request(
      {
        url: '/amazonLightningShare/pageAmazonLightningShareDetail',
        method: 'post',
        desc: ' amazon 对账 仓储费 详细 列表数据',
      },
      {
        ...data,
      },
      options
    )
  },

  /**
   * amazon 对账 移除费 总览 列表数据
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchListAmazonRemoveFeeOverview(data = {}, options = {}) {
    return request(
      {
        url: '/amazonRemovalShare/pageAmazonRemovalShare',
        method: 'post',
        desc: ' amazon 费用对账 移除费 总览 列表数据',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * amazon 对账 LD费 明细 列表数据
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchListAmazonRemoveFeeDetail(data = {}, options = {}) {
    return request(
      {
        url: '/amazonRemovalShare/pageAmazonRemovalShareDetail',
        method: 'post',
        desc: ' amazon 费用对账 移除费 详细 列表数据',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 回款记录-shopee
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchListSettmentRecordsShopee(data = {}, options = {}) {
    return request(
      {
        url: '/orderEsc/payoutlist',
        method: 'post',
        desc: '回款记录-shopee',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 回款记录/结算记录 shopee 本土店
   * @param {df} data
   * @param {*} options
   * @returns
   */
  fetchListSettlementRecordsShopeeLocalShop(data = {}, options = {}) {
    return request(
      {
        url: '/orderEsc/walletlist',
        method: 'post',
        desc: '回款记录-shopee-本土店',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 回款记录-shopee-总计
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchShopeeSettmentRecordsTotal(data = {}, options = {}) {
    return request(
      {
        url: '/orderEsc/payoutsummary',
        method: 'post',
        desc: '回款记录-shopee-总计',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * lazada-回款记录-列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchLazadaSettmentRecordsList(data = {}, options = {}) {
    return request(
      {
        url: '/lazadaFinance/settlementRecord',
        method: 'post',
        desc: 'lazada-回款记录-列表',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * ae-无物流费-信息
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchAeNoLogisticsFeeInfo(data = {}, options = {}) {
    return request(
      {
        url: '/aeFinance/profit/order/tips',
        method: 'post',
        desc: 'ae-无物流费-信息',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchAeProfitShopTips(data = {}, options = {}) {
    return request(
      {
        url: '/aeBill/tips',
        method: 'post',
        desc: 'ae-利润报表-店铺-提示信息',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchPurchaseSaleStockReportAe(data = {}, options = {}) {
    return request(
      {
        url: '/ae/warehouse/inventory/report',
        method: 'post',
        desc: '进销存报表-ae',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchProfitReportWishOrderList(data = {}, options = {}) {
    return request(
      {
        url: '/wish/profit/order',
        method: 'post',
        desc: '利润报表-wish-订单-列表',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchProfitReportWishOrderSum(data = {}, options = {}) {
    return request(
      {
        url: '/wish/profit/order/summary',
        method: 'post',
        desc: '利润报表-wish-订单-总计',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchAeBatchCostList(data = {}, options = {}) {
    return request(
      {
        url: '/ae/warehouse/batch/list',
        method: 'post',
        desc: '速卖通-批次成本-列表',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchAeBatchCostSummary(data = {}, options = {}) {
    return request(
      {
        url: '/ae/warehouse/batch/summary',
        method: 'post',
        desc: '速卖通-批次成本-总计',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchAeWarehouseDeductionDetailList(data = {}, options = {}) {
    return request(
      {
        url: '/ae/warehouse/detail/list',
        method: 'post',
        desc: '速卖通-仓库-扣减明细-列表',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchAeWarehouseDeductionDetailSummary(data = {}, options = {}) {
    return request(
      {
        url: '/ae/warehouse/detail/summary',
        method: 'post',
        desc: '速卖通-仓库-扣减明细-列表',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchAeBatchCostImport(data = {}, options = {}) {
    return request(
      {
        url: '/ae/warehouse/cost/callBack',
        method: 'post',
        desc: '速卖通-仓库-批次成本-导入',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchAeBatchCostTips(data = {}, options = {}) {
    return request(
      {
        url: '/ae/warehouse/batch/tips',
        method: 'post',
        desc: '速卖通-仓库-批次成本-提示信息',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 头程对账-列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchFirstCarryCostCheckList(data = {}, options = {}) {
    return request(
      {
        url: '/check/getFirstVessel/checkInfo',
        method: 'post',
        desc: '头程对账-列表',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 头程对账-仓库列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchFirstCarryCostCheckWarehouseList(data = {}, options = {}) {
    return request(
      {
        url: '/check/getWarehouseNames',
        method: 'post',
        desc: '头程对账-仓库列表',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 头程对账-物流公司
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchFirstCarryCostCheckLogisticsCompanyList(data = {}, options = {}) {
    return request(
      {
        url: '/check/getLogisticsNames',
        method: 'post',
        desc: '头程对账-物流公司',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 头程对账-调整分摊明细
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchFirstCarryCostCheckAdjustShareDetail(data = {}, options = {}) {
    return request(
      {
        url: '/check/getCheckDetails',
        method: 'get',
        desc: '头程对账-调整分摊明细',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 头程对账-核销
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchFirstCarryCostCheckVerification(data = {}, options = {}) {
    return request(
      {
        url: '/check/verification/firstVessel',
        method: 'post',
        desc: '头程对账-核销',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 头程对账-创建人可选项
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchFirstCarryCostCheckCreatorList(data = {}, options = {}) {
    return request(
      {
        url: '/check/getFirstVesselVerificationCreater',
        method: 'get',
        desc: '头程对账-创建人可选项',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 物流账单-导入创建人
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchLogisticsBillImportCreatorList(data = {}, options = {}) {
    return request(
      {
        url: '/check/getImportCreater',
        method: 'get',
        desc: '物流账单-导入创建人',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 物流账单-头程-导入列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchLogisticsBillFirstCarryImportList(data = {}, options = {}) {
    return request(
      {
        url: '/check/getFirstVessel/import',
        method: 'post',
        desc: '物流账单-头程-导入列表',
      },
      {
        ...data,
      },
      options
    )
  },
  fetchDelLogisticsBillFirstCarry(data = {}, options = {}) {
    return request(
      {
        url: '/check/removeImportFirstVesselByIds',
        method: 'post',
        desc: '删除-物流账单-头程',
      },
      data,
      options
    )
  },
  /**
   * 物流账单-头程-物流公司可选项
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchLogisticsBillFirstCarryLogisticsCompanyOptions(data = {}, options = {}) {
    return request(
      {
        url: '/check/getImportLogisticsNames',
        method: 'post',
        desc: '物流账单-头程-物流公司可选项',
      },
      data,
      options
    )
  },
  /**
   * 物流账单-头程-未关联的数量
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchLogisticsBillFirstCarryUnLinkCount(data = {}, options = {}) {
    return request(
      {
        url: '/check/getUnConnectedCount',
        method: 'get',
        desc: '物流账单-头程-未关联的数量',
      },
      data,
      options
    )
  },
  /**
   * 物流账单-头程-出库单列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchLogisticsBillFirstCarryStockOutBillList(data = {}, options = {}) {
    return request(
      {
        url: '/check/getStockoutInfo',
        method: 'post',
        desc: '物流账单-头程-出库单列表',
      },
      data,
      options
    )
  },
  /**
   * 物流账单-头程-出库单列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchLogisticsBillFirstCarryLinkAllocateStockOutBill(data = {}, options = {}) {
    return request(
      {
        url: '/check/checkAfterConnected',
        method: 'post',
        desc: '物流账单-头程-关联调拨出库单',
      },
      data,
      options
    )
  },
  /**
   * 物流账单-尾程-列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchLogisticsBillTailCostList(data = {}, options = {}) {
    return request(
      {
        url: '/check/getLogisticCenter',
        method: 'post',
        desc: '物流账单-尾程-列表',
      },
      data,
      options
    )
  },
  /**
   * 删除-物流账单-尾程
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchDelLogisticsBillTailCost(data = {}, options = {}) {
    return request(
      {
        url: '/check/removeImportTailVesselByIds',
        method: 'post',
        desc: '删除-物流账单-尾程',
      },
      data,
      options
    )
  },
  fetchLogisticsBillTailCostLinkSystemBill(data = {}, options = {}) {
    return request(
      {
        url: '/check/tailVessel/connected',
        method: 'post',
        desc: '物流账单-关联系统订单',
      },
      data,
      options
    )
  },
  fetchLogisticsBillTailCostLogisticsNameOptions(data = {}, options = {}) {
    return request(
      {
        url: '/check/getTailChannelName',
        method: 'post',
        desc: '物流账单-尾程-物流名称可选项',
      },
      data,
      options
    )
  },
  /**
   * 成本调整单-用户列表
   * @param {*} data {type: String}  1 创建人 2 审核人
   * @param {*} options
   * @returns
   */
  fetchCostAdjustBillUserOptions(data = {}, options = {}) {
    return request(
      {
        url: '/costAdjustment/queryAccountInfo',
        method: 'get',
        desc: '成本调整单-用户列表',
      },
      data,
      options
    )
  },
  fetchCostAdjustBillStatusCount(data = {}, options = {}) {
    return request(
      {
        url: '/costAdjustment/queryNumberOfTabStatus',
        method: 'get',
        desc: '成本调整单-状态合计',
      },
      data,
      options
    )
  },
  /**
   * 成本调整单-列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchCostAdjustBillList(data = {}, options = {}) {
    return request(
      {
        url: '/costAdjustment/queryPageInfo',
        method: 'post',
        desc: '成本调整单-列表',
      },
      data,
      options
    )
  },
  /**
   * 成本调整单-新增-选择表格-仓库可选项
   * @param {*} data {adjustmentType: String} 调整单类型
   * @param {*} options
   * @returns
   */
  fetchCostAdjustBillCheckTableWarehouseOptions(data = {}, options = {}) {
    return request(
      {
        url: '/costAdjustment/queryWarehouseInfo',
        method: 'get',
        desc: '成本调整单-新增-选择表格-仓库可选项',
      },
      data,
      options
    )
  },
  /**
   * 成本调整单-新增-选择表格列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchCostAdjustBillCheckTableList(data = {}, options = {}) {
    return request(
      {
        url: '/costAdjustment/queryAdjustmentData',
        method: 'post',
        desc: '成本调整单-新增-选择表格列表',
      },
      data,
      options
    )
  },
  /**
   * 成本调整单-新增
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchCreateCostAdjustBill(data = {}, options = {}) {
    return request(
      {
        url: '/costAdjustment/commit',
        method: 'post',
        desc: '成本调整单-新增',
      },
      data,
      options
    )
  },
  /**
   * 成本调整单-详情
   * @param {*} data {id: xxx}
   * @param {*} options
   * @returns
   */
  fetchCostAdjustBillDetail(data = {}, options = {}) {
    return request(
      {
        url: '/costAdjustment/queryCostAdjustTicketDetailOfAudit',
        method: 'get',
        desc: '成本调整单-详情',
      },
      data,
      options
    )
  },
  /**
   * 成本调整单-审核
   * @param {*} data {idList: []}
   * @param {*} options
   * @returns
   */
  fetchCostAdjustBillCheck(data = {}, options = {}) {
    return request(
      {
        url: '/costAdjustment/audit',
        method: 'post',
        desc: '成本调整单-审核',
      },
      data,
      options
    )
  },
  /**
   * 成本调整单-驳回
   * @param {*} data {idList: []}
   * @param {*} options
   * @returns
   */
  fetchCostAdjustBillReject(data = {}, options = {}) {
    return request(
      {
        url: '/costAdjustment/reject',
        method: 'post',
        desc: '成本调整单-驳回',
      },
      data,
      options
    )
  },
  /**
   * 成本调整单-编辑
   * @param {*} data {id: '', adjustmentRequestList: []}
   * @param {*} options
   * @returns
   */
  fetchUpdateCostAdjustBill(data = {}, options = {}) {
    return request(
      {
        url: '/costAdjustment/edit',
        method: 'post',
        desc: '成本调整单-编辑',
      },
      data,
      options
    )
  },
  /**
   * 成本调整单-删除
   * @param {*} data { adjustmentTicketIdList: [] }
   * @param {*} options
   * @returns
   */
  fetchDelCostAdjustBill(data = {}, options = {}) {
    return request(
      {
        url: '/costAdjustment/deleted',
        method: 'post',
        desc: '成本调整单-删除',
      },
      data,
      options
    )
  },
  fetchGetCheckOutSettings(data = {}, options = {}) {
    return request(
      {
        url: '/finance/profit/payout/setting/get',
        method: 'post',
        desc: '结账-获取设置',
      },
      data,
      options
    )
  },
  fetchSetCheckOutSettings(data = {}, options = {}) {
    return request(
      {
        url: '/finance/profit/payout/setting',
        method: 'post',
        desc: '结账-设置',
      },
      data,
      options
    )
  },
  fetchCheckOut(data = {}, options = {}) {
    return request(
      {
        url: '/finance/profit/payout/settle',
        method: 'post',
        desc: '结账',
      },
      data,
      options
    )
  },
  fetchCheckOutList(data = {}, options = {}) {
    return request(
      {
        url: '/finance/profit/payout/list/month',
        method: 'post',
        desc: '结账-账期列表',
      },
      data,
      options
    )
  },
  fetchCheckOutReverse(data = {}, options = {}) {
    return request(
      {
        url: '/finance/profit/payout/resettle',
        method: 'post',
        desc: '结账-反结账',
      },
      data,
      options
    )
  },
  fetchCheckOutCostCompute(data = {}, options = {}) {
    return request(
      {
        url: '/finance/profit/payout/costing',
        method: 'post',
        desc: '结账-成本计算',
      },
      data,
      options
    )
  },
  fetchCheckOutOperateLogList(data = {}, options = {}) {
    return request(
      {
        url: '/finance/profit/payout/log/list',
        method: 'post',
        desc: '结账-日志列表',
      },
      data,
      options
    )
  },

}
